@if (profile) {
  <div class="export-actions" [class.column]="columnStyle">
    <app-download-profile-c-v
      [profile]="profile"
      [image]="image"
      [isFullProfile]="isFullProfile"
      [forSearchPage]="forSearchPage"
      [limitAccess]="limitAccess"
      [disabled]="isExportInProgress"
      (downloadInProgress)="onDownLoadInProgress($event)"></app-download-profile-c-v>
    <app-add-profile-to-campaign
      [campaignCount]="actionsInfo?.campaignCount"
      [profileDocId]="profile.docId"
      [folderId]="folderId"
      (added)="onProfileAddedToCampaign()"></app-add-profile-to-campaign>
    @if (withCsIntegration) {
      <app-locked-action [locked]="(isLimited$ | async) ?? false">
        <app-export-profile-to-cs
          [profile]="profile"
          [limitAccess]="limitAccess"
          [profileHeader]="profileHeader"
          [disabled]="isDownloadInProgress"
          (modalPendingChange)="onExportInProgress($event)"></app-export-profile-to-cs>
      </app-locked-action>
    }
  </div>
}
